exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".table.table-condensed tbody tr td[data-v-5bb38ed8],.table.table-condensed tbody tr td [data-v-5bb38ed8]:not(.dropdown-default),.table.table-condensed thead tr th[data-v-5bb38ed8]{font-size:12px}.table.table-condensed tbody tr td.fs-18 [data-v-5bb38ed8]:not(.dropdown-default),.table.table-condensed tbody tr td.fs-18[data-v-5bb38ed8],.table.table-condensed thead tr th.fs-18[data-v-5bb38ed8]{font-size:18px}.font-montserrat.small[data-v-5bb38ed8]{font-size:12px}.split-container[data-v-5bb38ed8]{height:calc(100% - 100px)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-5bb38ed8","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Organizations.vue
// module id = 1368
// module chunks = 1